__webpack_require__.p = "https://www.mf-users-ping.pismolabs.io/";